import { useEffect } from "react";

import { ProductKeys } from "@atlassiansox/asc-stargate";

import { TemplateCategory } from "@/components/confluence/templates/template-categories-search";
import { CrossFlowTouchpointProvider } from "@/components/cross-flow/touchpoint";
import type {
    Template,
    TemplateCollection
} from "@/content/templates/template.types";
import { ConfluenceTemplatesPageTemplate } from "@/templates/software/confluence/templates/confluence-templates-page/src";
import { experiments, useExperimentExposure } from "@/utils/experiment";

export type ConfluenceTemplatesPageProps = {
    templates?: Template[];
    partnerTemplates?: Template[];
    collections?: TemplateCollection[];
    categories?: TemplateCategory[];
};

export const ConfluenceTemplatesPage = ({
    templates,
    partnerTemplates,
    collections,
    categories
}: ConfluenceTemplatesPageProps) => {
    const [relayExposureFired, fireRelayExposure] = useExperimentExposure(
        experiments.gwpAddRelayToConfluenceTemplatesLanding
    );

    useEffect(() => {
        if (!relayExposureFired) {
            fireRelayExposure();
        }
    }, [fireRelayExposure, relayExposureFired]);

    return (
        <CrossFlowTouchpointProvider productKeys={[ProductKeys.CONFLUENCE]}>
            <ConfluenceTemplatesPageTemplate
                templates={templates}
                partnerTemplates={partnerTemplates}
                collections={collections}
                categories={categories}
            />
        </CrossFlowTouchpointProvider>
    );
};
